import { Calendar, Share2, HelpCircle, Music, Mic, Sparkles, MonitorSmartphone, CloudUpload } from 'lucide-react';
import '@/App.css';

const PAGES = {
  schedule: { icon: Calendar, title: 'Schedule', desc: 'Manage your event schedule, claim shifts, and track your weekly calendar.', accent: '#fbdd68' },
  socials: { icon: Share2, title: 'Socials', desc: 'Connect and manage your social media presence for events.', accent: '#f472b6' },
  trivia: { icon: HelpCircle, title: 'Trivia', desc: 'Set up trivia rounds, manage question packs, and track game history.', accent: '#fbdd68' },
  bingo: { icon: Music, title: 'Bingo', desc: 'Manage Music Bingo song lists, themes, and custom playlists.', accent: '#c084fc' },
  karaoke: { icon: Mic, title: 'Karaoke', desc: 'Browse and manage karaoke song libraries and singer queues.', accent: '#22d3ee' },
};

export default function PlaceholderPage({ pageKey }) {
  const page = PAGES[pageKey] || PAGES.socials;
  const Icon = page.icon;

  return (
    <div data-testid={`${pageKey}-page`}>
      <div className="mb-8">
        <p className="text-[10px] font-mono uppercase tracking-[0.3em] mb-1.5" style={{ color: `${page.accent}cc` }}>Show Content</p>
        <h1 className="text-2xl sm:text-3xl font-extrabold text-white tracking-tight flex items-center gap-3">
          <span className="w-11 h-11 rounded-xl flex items-center justify-center border"
            style={{ backgroundColor: `${page.accent}1a`, borderColor: `${page.accent}33` }}>
            <Icon className="w-6 h-6" style={{ color: page.accent }} />
          </span>
          {page.title}
        </h1>
        <p className="text-sm text-[#8892b0] mt-2">{page.desc}</p>
      </div>

      <div className="glass-panel rounded-2xl p-10 sm:p-14 text-center relative overflow-hidden animate-fade-in-up">
        <div className="relative z-10">
          <div className="w-20 h-20 mx-auto mb-6 rounded-2xl flex items-center justify-center border"
            style={{ backgroundColor: `${page.accent}14`, borderColor: `${page.accent}40`, boxShadow: `0 0 40px ${page.accent}26` }}>
            <Icon className="w-10 h-10" style={{ color: page.accent }} />
          </div>
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-[11px] font-bold uppercase tracking-[0.2em] border mb-5"
            style={{ color: page.accent, borderColor: `${page.accent}4d`, backgroundColor: `${page.accent}0f` }}
            data-testid={`${pageKey}-coming-soon-badge`}>
            <Sparkles className="w-3.5 h-3.5" /> Coming soon to the stage
          </span>
          <h2 className="text-2xl font-extrabold text-white mb-3 tracking-tight">The {page.title} module is in rehearsal</h2>
          <p className="text-sm text-[#8892b0] max-w-md mx-auto leading-relaxed">
            It will integrate with your BIG Hat Entertainment desktop program, so everything you build here shows up at the venue.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-lg mx-auto mt-8 text-left">
            <div className="flex items-start gap-3 p-4 rounded-xl bg-[rgba(0,14,42,0.5)] border border-[rgba(251,221,104,0.1)] panel-glow">
              <CloudUpload className="w-4 h-4 mt-0.5 shrink-0" style={{ color: page.accent }} />
              <div>
                <p className="text-xs font-bold text-white">Cloud-managed content</p>
                <p className="text-[11px] text-[#8892b0] mt-0.5">Upload once, every linked PC stays in sync.</p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 rounded-xl bg-[rgba(0,14,42,0.5)] border border-[rgba(251,221,104,0.1)] panel-glow">
              <MonitorSmartphone className="w-4 h-4 mt-0.5 shrink-0" style={{ color: page.accent }} />
              <div>
                <p className="text-xs font-bold text-white">Program integration</p>
                <p className="text-[11px] text-[#8892b0] mt-0.5">Pushes straight into the desktop show-runner.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
